import { useState } from 'react';
import { Menu, X, ExternalLink } from 'lucide-react';

// Status page is a separate single-page site (no react-router) so cross-site
// links go to www.androhost.com as hard URLs. Keeps the surface visually
// identical to the marketing navbar without depending on the marketing app.

const WWW = 'https://www.androhost.com';

interface NavItem { name: string; href: string }
const NAV_ITEMS: NavItem[] = [
  { name: 'Games',     href: `${WWW}/#games` },
  { name: 'Servers',   href: `${WWW}/servers` },
  { name: 'Modpacks',  href: `${WWW}/modpacks` },
  { name: 'Blog',      href: `${WWW}/blog` },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-navy/85 border-b border-teal/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <a href={WWW} className="flex items-center gap-3 group flex-shrink-0">
            <img
              src="/androhost-rocket.svg"
              alt="AndroHost"
              className="h-9 md:h-10 w-auto group-hover:scale-110 transition-transform duration-300"
            />
            <span className="display text-xl md:text-2xl tracking-wider text-offwhite">
              ANDRO<span className="text-red">HOST</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-medium text-offwhite/80 hover:text-teal transition-colors"
              >
                {item.name}
              </a>
            ))}
            <span className="text-sm font-medium text-teal" aria-current="page">
              Status
            </span>
            <a
              href="https://www.androhost.com/account"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Game Panel
            </a>
          </nav>

          <button
            className="lg:hidden text-offwhite flex-shrink-0"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-navy border-t border-teal/10">
          <div className="container mx-auto px-4 py-4">
            <nav className="flex flex-col space-y-3">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-offwhite/80 font-medium hover:text-teal py-1"
                  onClick={() => setMobileOpen(false)}
                >
                  {item.name}
                </a>
              ))}
              <span className="text-teal font-medium py-1" aria-current="page">
                Status
              </span>
              <a
                href="https://www.androhost.com/account"
                className="btn-primary w-full text-center"
                target="_blank"
                rel="noopener noreferrer"
              >
                Game Panel <ExternalLink className="w-3.5 h-3.5 ml-1.5 inline" />
              </a>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}
